import * as React from "react";
const SvgGraphicCard = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.438 1.69v2.996H4.686v3.753H1.689V9.936h2.997v4.128H1.689v1.499h2.997v3.751h3.752v2.997h1.498v-2.997h4.128v2.997H15.561v-2.997h3.753v-3.751h2.997v-1.499h-2.997V9.936h2.997V8.439h-2.997V4.686h-3.753V1.689H14.064v2.997H9.936V1.689h-.748ZM6.19 6.19H17.81V17.81H6.19V12ZM12 14.064v1.499h3.754v-1.499h-1.877z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgGraphicCard;
